import React from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { App } from "./App";
import { LoginPage } from "./pages/LoginPage";
import { History } from "./pages/History";
import { WithdrawalsPage } from "./pages/WithdrawalsPage/WithdrawalsPage";

export const Root: React.FC = () => (
  <Router>
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route path="/" element={<App />}>
        <Route index element={<History />} />
        <Route path="withdrawals" element={<WithdrawalsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);
